import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCar5: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="car-5"><path d="M19.75 17.25H22.25V13.3208C22.25 12.3111 21.8682 11.3388 21.1812 10.599L16.9369 6.02819C16.18 5.21313 15.118 4.75 14.0057 4.75H3.75L1.75 17.25H4.25" stroke="currentColor" strokeWidth="1.5"/><path d="M9.5 17.25H14.5" stroke="currentColor" strokeWidth="1.5"/><path d="M9.75 17.25H14.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="7" cy="16.75" r="2.5" stroke="currentColor" strokeWidth="1.5"/><circle cx="17" cy="16.75" r="2.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCar5;
